import axios from 'axios'

class FornecedorService {
  // Buscar todos os fornecedores
  async getAll(params = {}) {
    try {
      const { data } = await axios.get('api/v1/tenants/fornecedores/', { params })
      return data
    } catch (error) {
      console.error('Erro ao buscar fornecedores:', error)
      return Promise.reject(error)
    }
  }

  // Buscar fornecedores de um gate específico
  async getByGate(gateId, params = {}) {
    try {
      const { data } = await axios.get(`api/v1/tenants/gates/${gateId}/fornecedores/`, { params })
      return data
    } catch (error) {
      console.error('Erro ao buscar fornecedores por gate:', error)
      return Promise.reject(error)
    }
  }

  // Buscar fornecedor específico
  async get(publicId) {
    try {
      const { data } = await axios.get(`api/v1/tenants/fornecedores/${publicId}/`)
      return data
    } catch (error) {
      console.error('Erro ao buscar fornecedor:', error)
      return Promise.reject(error)
    }
  }

  // Buscar terminais do gate (todos os terminais disponíveis através dos fornecedores do gate)
  async getTerminaisGate(gateId) {
    try {
      const { data } = await axios.get(`api/v1/tenants/gates/${gateId}/fornecedores/terminais-gate/`)
      return data
    } catch (error) {
      console.error('Erro ao buscar terminais do gate:', error)
      return Promise.reject(error)
    }
  }

  // Buscar terminais combinados (gate + fornecedor específico)
  async getTerminaisCombinados(gateId, fornecedorId) {
    try {
      const { data } = await axios.get(`api/v1/tenants/gates/${gateId}/fornecedores/${fornecedorId}/terminais/`)
      return data
    } catch (error) {
      console.error('Erro ao buscar terminais combinados:', error)
      return Promise.reject(error)
    }
  }

  // Buscar terminais (que são Tenants) relacionados ao fornecedor
  async getTerminais(fornecedorId) {
    try {
      // Busca Tenants que podem ser usados como terminais para este fornecedor
      const { data } = await axios.get(`api/v1/tenants/tenants/`, {
        params: { 
          fornecedor: fornecedorId  // Usa o filtro existente do TenantFilter
        }
      })
      return data
    } catch (error) {
      console.error('Erro ao buscar terminais:', error)
      return Promise.reject(error)
    }
  }

  // Método legado - buscar terminais específicos do fornecedor
  async getTerminaisFornecedor(fornecedorId) {
    try {
      const { data } = await axios.get(`api/v1/tenants/tenants/`, {
        params: { 
          fornecedor: fornecedorId
        }
      })
      return data
    } catch (error) {
      console.error('Erro ao buscar terminais do fornecedor:', error)
      return Promise.reject(error)
    }
  }
}

export default new FornecedorService()